/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../../apiClient'
import type {
  ListVariantImagesQueryResponse,
  ListVariantImagesPathParams,
  ListVariantImages404,
} from '../../types/ListVariantImages'
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { listVariantImages } from '../../clients/listVariantImages'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const listVariantImagesQueryKey = ({
  variant_id,
}: {
  variant_id: ListVariantImagesPathParams['variant_id']
}) =>
  [
    {
      url: '/api/v1/products/catalog/variants/:variant_id/images/',
      params: { variant_id: variant_id },
    },
  ] as const

export type ListVariantImagesQueryKey = ReturnType<
  typeof listVariantImagesQueryKey
>

export function listVariantImagesQueryOptions(
  { variant_id }: { variant_id: ListVariantImagesPathParams['variant_id'] },
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey = listVariantImagesQueryKey({ variant_id })
  return queryOptions<
    ListVariantImagesQueryResponse,
    ResponseErrorConfig<ListVariantImages404>,
    ListVariantImagesQueryResponse,
    typeof queryKey
  >({
    enabled: !!variant_id,
    queryKey,
    queryFn: async ({ signal }) => {
      return listVariantImages(
        { variant_id: variant_id },
        { ...config, signal: config.signal ?? signal }
      )
    },
  })
}

/**
 * @description Get all images for a variant.
 * Args:
 * variant_id: ID of the variant
 * Returns:
 * Response with list of images including is_main flag
 * @summary List variant images
 * {@link /api/v1/products/catalog/variants/:variant_id/images/}
 */
export function useListVariantImages<
  TData = ListVariantImagesQueryResponse,
  TQueryData = ListVariantImagesQueryResponse,
  TQueryKey extends QueryKey = ListVariantImagesQueryKey,
>(
  { variant_id }: { variant_id: ListVariantImagesPathParams['variant_id'] },
  options: {
    query?: Partial<
      QueryObserverOptions<
        ListVariantImagesQueryResponse,
        ResponseErrorConfig<ListVariantImages404>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey =
    resolvedOptions?.queryKey ?? listVariantImagesQueryKey({ variant_id })

  const query = useQuery(
    {
      ...listVariantImagesQueryOptions({ variant_id }, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<ListVariantImages404>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
